import Axios from "axios";

export default class ScratchAPIProvider {
  static getProjectData = async (projectID) => {
    const res = await Axios.get(
      `https://cors-anywhere.herokuapp.com/https://api.scratch.mit.edu/projects/${projectID}`,
      {
        headers: { "X-Requested-With": "application/json" },
      }
    );

    return res.data;
  };
}
